import index from "./examPoint.vue";
export default index;
